export default __webpack_public_path__ + "static/media/product-list.8357061b.svg";